/**
 * 列表页 CTR 埋点 · select_item 点击（jovellee · hyt-pm docs/shopify-tracking-spec.md §3.5）
 *
 * 做什么：collection 页点击商品卡内详情页链接时发一条 GA4 select_item。
 *
 * 发送通道：主文档 gtag 直发 GA4（send_to G-GPWR7B9G5C）。jovellee theme.liquid 注入
 * GTM-K34RJG58 在主文档（非 sandbox），GTM 加载 gtag.js，window.gtag 可用。
 * GTM 容器的 select_item 触发器未生效（可能是 Custom Event 类型而非 Click），
 * 故由本脚本直接通过 gtag 直发，不依赖 GTM 触发器。
 *
 * 口径：data-sku 为空不采集；每次点击独立计数；仅 collection section 加载。
 */
(function () {
  'use strict';
  if (window.__jovListCtrLoaded) return;
  window.__jovListCtrLoaded = true;

  var MEASUREMENT_ID = 'G-GPWR7B9G5C';

  /**
   * 从点击的 <a> 元素读取 data 属性，拼装 GA4 select_item 参数。
   * @param {HTMLAnchorElement} el - 带 data-sku 的 <a> 元素
   * @returns {Object|null} GA4 事件参数对象；sku 为空时返回 null 跳过
   */
  function payload(el) {
    var sku = el.getAttribute('data-sku');
    if (!sku) return null;
    var index = parseInt(el.getAttribute('data-index'), 10);
    var item = {
      item_id: sku,
      item_name: el.getAttribute('data-item-name') || '',
      item_list_name: el.getAttribute('data-list-name') || '',
      item_list_id: el.getAttribute('data-list-id') || ''
    };
    if (index >= 1) item.index = index;
    return {
      item_list_name: item.item_list_name,
      item_list_id: item.item_list_id,
      ctr_source: 'theme',
      send_to: MEASUREMENT_ID,
      transport_type: 'beacon',
      items: [item]
    };
  }

  /**
   * 等待 window.gtag 可用后发送。GTM 异步加载 gtag.js，
   * 脚本可能先于 gtag 就绪：最多重试 5 次 × 1.5s。
   * @param {string} eventName - GA4 事件名
   * @param {Object} data - payload() 返回的参数对象
   * @param {number} [attempt=0] - 当前重试次数
   */
  function send(eventName, data, attempt) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, data);
      return;
    }
    if ((attempt || 0) < 5) {
      setTimeout(function () { send(eventName, data, (attempt || 0) + 1); }, 1500);
    }
  }

  /**
   * document 捕获阶段监听点击，匹配 a[data-sku] 触发 select_item。
   * 使用事件委托：无限滚动/AJAX 翻页无需额外绑定。
   */
  document.addEventListener('click', function (ev) {
    var anchor = ev.target && ev.target.closest
      ? ev.target.closest('a[data-sku]')
      : null;
    if (!anchor) return;
    var data = payload(anchor);
    if (!data) return;
    send('select_item', data);
  }, true);
})();
